import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Automatically scrolls window and scrollable layout containers
 * to the top on every route navigation.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // Reset window and document scroll
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });

      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Reset dashboard main content layout scroll if present
      const mainContent = document.querySelector(".main-content-layout");
      if (mainContent) {
        mainContent.scrollTop = 0;
      }
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
